import { render, staticRenderFns } from "./Traspasos.vue?vue&type=template&id=3f644a7f"
import script from "./Traspasos.vue?vue&type=script&lang=js"
export * from "./Traspasos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports